import { Paper, Stack, SxProps, Theme, Typography } from '@mui/material';
import { ReactNode } from 'react';

export interface TitledPaperProps {
  title: string;
  icon?: JSX.Element;
  children: ReactNode;
  color?: string;
  sx?: SxProps<Theme> | undefined;
  elementTopRight?: JSX.Element;
}

/**
 * @summary Generic component containing a paper with a title and an optional icon
 * Note that top level children are divided using MUI Divider components
 * @param title - string shown at the top of the paper
 * @public
 */
export const TitledPaper = (props: TitledPaperProps) => {
  const { title, icon, children, color, sx, elementTopRight } = props;

  return (
    <Stack direction="row" height="inherit" sx={{ minWidth: 0 }}>
      <Paper
        elevation={0}
        square={true}
        sx={{
          ...sx,
          background: color,
          display: 'flex',
          flexDirection: 'column',
          width: '100%'
        }}>
        <Stack direction={'row'} spacing={1} padding={1}>
          {icon}
          <Typography variant={'h3'} sx={{ marginRight: 'auto' }}>
            {title}
          </Typography>
          {elementTopRight}
        </Stack>
        {children}
      </Paper>
    </Stack>
  );
};
